import { ThemeUIStyleObject } from 'theme-ui';

export const formContainerStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 30,
};

export const sectionStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const labelStyles: ThemeUIStyleObject = {
  marginBottom: 1,
};

export const dropZoneStyles = (isDragging: boolean, hasError: boolean): ThemeUIStyleObject => ({
  border: '2px dashed',
  borderColor: isDragging ? 'primary' : hasError ? 'error' : 'neutral/300',
  borderRadius: 'medium',
  padding: 4,
  textAlign: 'center',
  backgroundColor: isDragging ? 'primary/10' : 'neutral/50',
  cursor: 'pointer',
  transition: 'all 0.2s',
  '&:hover': {
    borderColor: 'primary',
    backgroundColor: 'primary/5',
  },
});

export const fileInfoStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const dateGridStyles: ThemeUIStyleObject = {
  display: 'grid',
  gridTemplateColumns: ['1fr', '1fr 1fr'],
  gap: 3,
};

export const dateInputStyles: ThemeUIStyleObject = {
  width: '100%',
  padding: '0.75rem 1rem',
  border: '1px solid',
  borderColor: 'neutral/300',
  borderRadius: 'medium',
  fontSize: '14px',
  fontFamily: 'body',
  '&:focus': {
    outline: 'none',
    borderColor: 'primary',
    boxShadow: '0 0 0 2px rgba(0, 112, 243, 0.1)',
  },
  '&:disabled': {
    backgroundColor: 'neutral/100',
    cursor: 'not-allowed',
  },
};

export const errorTextStyles: ThemeUIStyleObject = {
  marginTop: 1,
  color: 'error',
};

export const instructionsBoxStyles: ThemeUIStyleObject = {
  padding: 5,
  backgroundColor: 'info/10',
  borderRadius: 'medium',
  borderLeft: '4px solid',
  borderLeftColor: 'info',
};

export const instructionsTitleStyles: ThemeUIStyleObject = {
  marginBottom: 2,
};

export const instructionsListStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  color: 'neutral/700',
};
